import React, { useEffect, useState } from "react";
import CustomModal from "../../reusable/CustomModal/CustomModal";
// import { couponDiscount } from "../../assets/constants";
import CommonButton from "../../reusable/Button";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { couponType } from "../../helpers";

const ApplyCouponModal = ({
  visible,
  header,
  setVisible,
  footer,
  setOrderSumarry,
  orderSummary,
  totalItems,
  setCouponCode,
  couponCode,
  setDiscountData,
  dicountData,
}) => {
  const { discountResponse } = useSelector((state) => state.order);
  const { total_amount, shipping_fee } = useSelector((state) => state.cart);

  const [amount, setAmount] = useState();
  const [isActive, setIsActive] = useState({
    coupon: false,
    items: true,
  });

  const [data, setData] = useState(false);

  useEffect(() => {
    setIsActive({
      coupon: false,
      items: true,
    });
    if (discountResponse?.statusCode) {
      setData(discountResponse?.data);
    }
  }, [discountResponse]);

  const confirmHandler = () => {
    if (!amount) {
      toast.warn("Please select any discount!");
      return true;
    } else {
      if (isActive?.items) {
        setOrderSumarry({
          ...orderSummary,
          discount: Number(amount),
        });
        setVisible(false);
        setCouponCode("");
      }
      if (isActive?.coupon) {
        if (orderSummary?.couponDiscountType === "Percentage") {
          const discountAmount = (total_amount * amount) / 100;
          setOrderSumarry({
            ...orderSummary,
            discount: Number(discountAmount),
            discountType: "coupon",
            discountName: "coupon",
          });
          setVisible(false);
          setDiscountData({
            ...dicountData,
            couponCode: couponCode,
            discountApplied: 1,
          });
          toast.success("Coupon Applied Successfully.");
        } else {
          if (total_amount >= Number(amount)) {
            setOrderSumarry({
              ...orderSummary,
              discount: Number(amount),
              discountType: "coupon",
              discountName: "coupon",
            });
            setDiscountData({
              ...dicountData,
              couponCode: couponCode,
              discountApplied: 1,
            });
            setVisible(false);
            toast.success("Coupon Applied Successfully.");
          } else {
            toast.warn(
              `Your Coupon discount ($${amount}) is greater then subtotal, Please add more items.`
            );
          }
        }
      }
    }
  };
  return (
    <>
      <CustomModal
        visible={visible}
        title={header}
        onClose={setVisible}
        width={500}
        className="filter-modal"
        footer={footer}
      >
        <div className="my-1 p-3">
          <div className="w-100">
            <span
              className="d-flex mx-auto text-center mb-4"
              style={{ fontSize: "15px", fontWeight: "500", width: "85%" }}
            >
              You are eligible for below discounts. You can select any discount
              according to your choice.
            </span>
          </div>

          <div
            className={`cursor-pointer d-flex justify-content-between border-shadow my-3 p-3 ${
              isActive?.items && "active-border"
            }
            `}
            onClick={() => {
              setAmount(totalItems * data?.discountResponse?.discountPerItem);
              setIsActive({ coupon: false, items: true });
            }}
          >
            <div className="d-flex">
              <input
                checked={isActive?.items}
                type="radio"
                className="cursor-pointer"
                name={`itemsDiscount`}
                id={`itemsDiscount`}
              />
              <h6 className="ms-2 mt-1">Items Discount</h6>
            </div>

            <div className="mt-1">
              <h6>
                {totalItems}*
                {data?.discountResponse?.discountPerItem?.toFixed(2)}=$
                {(
                  totalItems * data?.discountResponse?.discountPerItem
                )?.toFixed(2)}
              </h6>
            </div>
          </div>

          <div
            className={`cursor-pointer d-flex justify-content-between border-shadow my-3 p-3 ${
              isActive?.coupon && "active-border"
            }
            `}
            onClick={() => {
              setOrderSumarry({
                ...orderSummary,
                couponDiscountType:
                  data?.couponResponse?.type === couponType?.Percentage
                    ? "Percentage"
                    : "Fixed",
              });
              setAmount(data?.couponResponse?.amount);
              setIsActive({ coupon: true, items: false });
            }}
          >
            <div className="d-flex">
              <input
                checked={isActive?.coupon}
                type="radio"
                className="cursor-pointer"
                name={`couponDiscount`}
                id={`couponDiscount}`}
              />
              <h6 className="ms-2 mt-2">Coupon Discount</h6>
            </div>

            <div className="mt-1">
              <h6>
                {data?.couponResponse?.type === couponType?.Percentage &&
                  data?.couponResponse?.amount + "%" + "="}
                {data?.couponResponse?.type === couponType?.Percentage &&
                  `${(total_amount * data?.couponResponse?.amount) / 100}`}
              </h6>
              <h6>
                {data?.couponResponse?.type === couponType?.Fixed &&
                  "$" + data?.couponResponse?.amount?.toFixed(2)}
              </h6>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center align-items-center pb-4">
          <CommonButton
            type="button"
            className="button outlined px-4 mx-3 rounded-1 my-2   "
            onClick={confirmHandler}
            lable={"Confirm"}
          />
        </div>
      </CustomModal>
    </>
  );
};

export default ApplyCouponModal;
